module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['edit_absence_request']))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('UserAbsence', {
    attrs: {
      "selectedSubject": _vm.selectedSubject,
      "resetCounter": _vm.resetAbsenceCounter
    },
    on: {
      "setSubject": _vm.setSelectedSubject
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n['date']))]), _vm._v(" "), _c('DatepickerRange', {
    attrs: {
      "allowSameDate": true,
      "startdate": _vm.initStartDate,
      "enddate": _vm.initEndDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time-changer__group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n['time']))]), _vm._v(" "), _c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-group marg-1-top"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n['optional_note']))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "do-input",
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), (_vm.selectedTab === 'request') ? _c('div', {
    staticClass: "d-modal__buttons d-modal__buttons__flex",
    staticStyle: {
      "padding": "1rem"
    }
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n                arrow: true,\n                animateFill: false,\n                animation : 'shift-away',\n                zIndex: '999999992',\n                boundary: 'window'\n              }"
    }],
    staticClass: "do-bttn do-bttn--danger",
    class: {
      'do-bttn--loading': _vm.isDeleting
    },
    attrs: {
      "content": _vm.i18n['delete_request_tooltip']
    },
    on: {
      "click": _vm.deleteRequest
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "do-submit-buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.update')) + "\n        ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.update')) + "\n        ")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-136b76ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRequests/UserRequestForm.vue
// module id = 1768
// module chunks = 1